import queryString from 'query-string'
import React from 'react'
import {useLocation} from 'react-router'

export const useQueryParamValues = (name: string): string[] => {
  const {search} = useLocation()
  return React.useMemo(() => {
    const value = queryString.parse(search)[name]
    if (!value) {
      return []
    }
    return Array.isArray(value) ? value : [value]
  }, [search, name])
}
